import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import "@/App.css";
import SmoothScroll from "@/components/SmoothScroll";
import Cursor from "@/components/Cursor";
import IntroOverlay from "@/components/IntroOverlay";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import FloatingActions from "@/components/FloatingActions";
import ChatbotWidget from "@/components/ChatbotWidget";
import Home from "@/pages/Home";
import ServicePage from "@/pages/ServicePage";
import LocalPage from "@/pages/LocalPage";
import ServiceCityPage from "@/pages/ServiceCityPage";
import ServiceDetailPage from "@/pages/ServiceDetailPage";
import AdminPage from "@/pages/AdminPage";
import { LOCAL_PAGES } from "@/data/localpages";
import { SERVICE_LOCAL_PAGES } from "@/data/servicelocalpages";
import { SERVICE_DETAIL_PAGES } from "@/data/servicedetailpages";
import { usePageTracker } from "@/hooks/usePageTracker";

function AppLayout() {
    const location = useLocation();
    const isAdmin = location.pathname.startsWith("/admin");
    usePageTracker();

    return (
        <>
            {!isAdmin && <SmoothScroll />}
            {!isAdmin && <Cursor />}
            {!isAdmin && <IntroOverlay />}
            {!isAdmin && <Navbar />}
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/nettoyage-syndrome-diogene-strasbourg" element={<ServicePage pageKey="diogene" />} />
                <Route path="/nettoyage-apres-deces-strasbourg" element={<ServicePage pageKey="deces" />} />
                {Object.entries(SERVICE_DETAIL_PAGES).map(([key, v]) => (
                    <Route key={key} path={`/${v.slug}`} element={<ServiceDetailPage pageKey={key} />} />
                ))}
                {Object.entries(LOCAL_PAGES).map(([key, v]) => (
                    <Route key={key} path={`/${v.slug}`} element={<LocalPage pageKey={key} />} />
                ))}
                {Object.entries(SERVICE_LOCAL_PAGES).map(([key, v]) => (
                    <Route key={key} path={`/${v.slug}`} element={<ServiceCityPage pageKey={key} />} />
                ))}
                <Route path="/admin" element={<AdminPage />} />
                <Route path="*" element={<Home />} />
            </Routes>
            {!isAdmin && <Footer />}
            {!isAdmin && <FloatingActions />}
            {!isAdmin && <ChatbotWidget />}
            <Toaster position="top-center" richColors />
        </>
    );
}

function App() {
    return (
        <HelmetProvider>
            <BrowserRouter>
                <AppLayout />
            </BrowserRouter>
        </HelmetProvider>
    );
}

export default App;
